import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Row, Col } from "antd";
import "swiper/css";
import "swiper/css/autoplay";

const bannerStyles = {
  container: {
    width: "100%",
    height: "200px",
    margin: "8px 0",
    borderRadius: "16px",
    overflow: "hidden",
    border: "1px solid #d9d9d9",
    opacity: 0.9,
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "16px",
  },
};

export default function Banner({ bannerInfo }) {
  return (
    <Row>
      <Col span={24}>
        <div style={bannerStyles.container}>
          <Swiper
            key={bannerInfo?.length}
            modules={[Autoplay]}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            loop={true}
            style={{ width: "100%", height: "100%" }}
          >
            {bannerInfo?.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img.url}
                  alt={`Banner ${index}`}
                  style={bannerStyles.image}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Col>
    </Row>
  );
}
